import './TabPanel.css';
export var tabPanelCSS = '_b4irt10-3-12-1';
export var tabPanelOverflowBehaviorCSS = {hidden:'_b4irt11-3-12-1','scroll-y':'_b4irt12-3-12-1'};